$(document).ready(function(){

	$('[data-fancybox]').fancybox({
	  backFocus: false,
	});

});